/* eslint-disable @typescript-eslint/no-require-imports */

/**
 * Get version from package.json in runtime, we don't want to resolve it at build time
 * wix infra bumps version automatically post build and we want to pick that version
 */
export const getVersion = (): string => {
    try {
        // get to package.json from src folder
        return require('../../package.json').version
    } catch (e) {
        try {
            // get to package.json from dist folder
            return require('../../../package.json').version
        } catch (error) {
            throw new Error('Cannot read version from package.json')
        }
    }
}
